import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_item_company_glcode_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_coa: fromDatatype.GuidDataFieldInterface;
  guid_item: fromDatatype.GuidDataFieldInterface;
  txn_code: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config:fromDatatype.JsonDatatypeInterface;
  acl_policy:fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_mst_item_company_glcode_link_RowClass implements bl_fi_mst_item_company_glcode_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_coa: fromDatatype.GuidDataFieldInterface;
  guid_item: fromDatatype.GuidDataFieldInterface;
  txn_code: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config:fromDatatype.JsonDatatypeInterface;
  acl_policy:fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}
